var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._v(" Impressions "),_c('info-tooltip',{attrs:{"content":"If creative for an ad is requested on a web page, it will count as an impression"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }